import { render } from "./ManufacturingOrderTable.vue?vue&type=template&id=629182de"
import script from "./ManufacturingOrderTable.vue?vue&type=script&lang=ts"
export * from "./ManufacturingOrderTable.vue?vue&type=script&lang=ts"
script.render = render

export default script